import { render, staticRenderFns } from "./Replys.vue?vue&type=template&id=70e2a182&scoped=true&"
import script from "./Replys.vue?vue&type=script&lang=js&"
export * from "./Replys.vue?vue&type=script&lang=js&"
import style0 from "./Replys.vue?vue&type=style&index=0&id=70e2a182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2a182",
  null
  
)

export default component.exports